/* eslint-disable import/prefer-default-export */
import {
  getOrganizations,
  getTeams,
  createTeam,
  deleteTeam,
  updateTeam,
  saveTree,
} from './api.service';
import { actions } from './reducer';

const {
  getTeamsRequest,
  getTeamsSuccess,
  getTeamsFailure,
  getOrganizationsRequest,
  getOrganizationsSuccess,
  getOrganizationsFailure,
  createTeamRequest,
  createTeamSuccess,
  createTeamFailure,
  updateTeamRequest,
  updateTeamSuccess,
  updateTeamFailure,
  deleteTeamRequest,
  deleteTeamSuccess,
  deleteTeamFailure,
  setOrganizationId,
} = actions;

export const fetchTeams = (initiativeId, organizationId) => async (dispatch) => {
  try {
    dispatch(getTeamsRequest());
    const { data } = await getTeams(initiativeId, organizationId);
    dispatch(getTeamsSuccess({ teams: data.data }));
  } catch (error) {
    dispatch(getTeamsFailure({ error }));
  }
};

export const fetchOrganizations = (initiativeId) => async (dispatch) => {
  try {
    dispatch(getOrganizationsRequest());
    const { data } = await getOrganizations(initiativeId);
    dispatch(getOrganizationsSuccess({ organizations: data.data }));
  } catch (error) {
    dispatch(getOrganizationsFailure({ error }));
  }
};

export const createNewTeam = (payload) => async (dispatch) => {
  try {
    dispatch(createTeamRequest());
    const { data } = await createTeam(payload);
    dispatch(createTeamSuccess({ team: data.data, success: 'Team has been created' }));
  } catch ({ response }) {
    const validError = response.data?.errors?.name;
    const error = validError ? validError[0] : 'Team could not be created';
    dispatch(getOrganizationsFailure({ error }));
    dispatch(createTeamFailure({ error }));
  }
};

export const updateTeamData = (payload) => async (dispatch) => {
  try {
    dispatch(updateTeamRequest());
    const { data } = await updateTeam(payload);
    dispatch(updateTeamSuccess({ team: data.data, success: 'Team has been updated' }));
  } catch (error) {
    dispatch(updateTeamFailure({ error }));
  }
};

export const deleteTeamById = (id, initiativeId) => async (dispatch) => {
  try {
    dispatch(deleteTeamRequest());
    const { data } = await deleteTeam(id, initiativeId);
    dispatch(
      deleteTeamSuccess({ deletedId: id, status: data.data, success: 'Team has been deleted' }),
    );
  } catch (error) {
    dispatch(deleteTeamFailure({ error }));
  }
};

export const saveTeamsTree = (tree, initiativeId) => async (dispatch) => {
  try {
    // dispatch(deleteTeamRequest());
    await saveTree(tree, initiativeId);
    // dispatch(deleteTeamSuccess({ deletedId: id, status: data.data, success: 'Team has been deleted' }));
  } catch (error) {
    // dispatch(deleteTeamFailure({ error }));
  }
};

export const setOrganization = (organizationId) => async (dispatch) => {
  dispatch(setOrganizationId({ organizationId }));
};
